import { Guid } from "@/types"
import Notification, { IGetNotification, NotificationType } from "./Notification"
import NotificationAsset from "models/NotificationAsset"

export interface IGetNotificationCollectiveReferenceNumberNotUpdatedDto extends IGetNotification {
    notificationType: NotificationType.collectiveReferenceNumberNotUpdated
    assets: Guid[]
    sale: boolean
}

export default class NotificationCollectiveReferenceNumberNotUpdated extends Notification {
    assetIds: Guid[]
    assets: NotificationAsset[]
    sale: boolean

    constructor(dto: IGetNotificationCollectiveReferenceNumberNotUpdatedDto) {
        super(dto)
        this.assetIds = dto.assets
        this.assets = dto.assets.map(assetId => new NotificationAsset({
            assetId: assetId
        }))
        this.sale = dto.sale
    }
}
